import React, { useState } from "react";
import { Card, Grid, TextField, Button, CircularProgress, Alert } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import api from "api/api";
import { useNavigate } from "react-router-dom";

function ChangePassword() {
  const [old_password, setold_password] = useState("");
  const [new_password, setnew_password] = useState("");
  const [confirm_password, setconfirm_password] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    // console.log("Token in localStorage :", localStorage.getItem("adminToken"));
    e.preventDefault();
    setError("");
    setSuccess("");

    if (new_password !== confirm_password) {
      setError("New password and confirm password do not match.");
      return;
    }

    try {
      setLoading(true);
      // console.log("Sending token:", token);
      await api.post("admin/change-password", {
        old_password,
        new_password,
        confirm_password,
      });

      setSuccess("Password changed successfully.");
      setold_password("");
      setnew_password("");
      setconfirm_password("");

      setTimeout(() => {
        navigate("/authentication/sign-in");
      }, 2000);
    } catch (err) {
      // console.log("Sending token:", token);
      const errorMsg = err.response?.data?.errors
        ? err.response.data.errors.join(", ")
        : err.response?.data?.message || "Failed to change password.";
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card sx={{ p: 3 }}>
              <MDTypography variant="h5" fontWeight="bold" mb={2}>
                Change Password
              </MDTypography>

              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
              {success && (
                <Alert severity="success" sx={{ mb: 2 }}>
                  {success}
                </Alert>
              )}

              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      type="password"
                      label="Current Password"
                      value={old_password}
                      onChange={(e) => setold_password(e.target.value)}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      type="password"
                      label="New Password"
                      value={new_password}
                      onChange={(e) => setnew_password(e.target.value)}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      type="password"
                      label="Confirm New Password"
                      value={confirm_password}
                      onChange={(e) => setconfirm_password(e.target.value)}
                      required
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      className="btn"
                      type="submit"
                      variant="contained"
                      color="primary"
                      fullWidth
                      disabled={loading}
                    >
                      {loading ? <CircularProgress size={24} color="inherit" /> : "Change Password"}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ChangePassword;
